import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { NOTIFICATION_TYPE } from '../../../constants/common'
import { ICON_HEIGHT_40, IconSpinner } from '../../Icon'
import Modal, { Box, Content, Header } from '../../Modal'
import { NotificationInline } from '../../Notification'

import {
  COLOR_STACK,
  QA_NAME_STATISTIC_MODAL,
  STATISTIC_CONTACT_TAB,
  STATISTIC_ROLE_TAB,
  STATISTIC_STATUS_TAB,
  STATISTIC_SUMMARY_TAB,
  TAB_COMPONENT,
} from './InhabitantsStatisticModal.constants'
import { useStatisticData } from './InhabitantsStatisticModal.hooks'
import { StatisticTabBody } from './StatisticTabBody'
import { StatisticTabs } from './StatisticTabs'

import * as styles from './InhabitantsStatisticModal.module.css'

function InhabitantsStatisticModal(props) {
  const { t } = useTranslation()

  const [activeTab, setActiveTab] = useState(STATISTIC_ROLE_TAB)

  const { allCount, contactData, roleData, statusData, summaryData } =
    useStatisticData()

  function handleClose() {
    props.onClose()
  }

  const tabData = {
    [STATISTIC_CONTACT_TAB]: contactData,
    [STATISTIC_ROLE_TAB]: roleData,
    [STATISTIC_STATUS_TAB]: statusData,
    [STATISTIC_SUMMARY_TAB]: summaryData,
  }

  return (
    <Modal qaName={QA_NAME_STATISTIC_MODAL} onClose={handleClose}>
      <Box>
        <Header
          text={t('Modal.InhebitantStatisticTitleKey')}
          onClose={handleClose}
        />
        <Content className={styles.content} size='xl'>
          <NotificationInline
            className={styles.notification}
            text={t('Inhabitant.StatisticInfoMessageKey')}
            type={NOTIFICATION_TYPE.info}
          />
          {summaryData ? (
            <>
              <StatisticTabs
                activeTab={activeTab}
                onSetActiveTab={setActiveTab}
              />
              <StatisticTabBody
                Component={TAB_COMPONENT[activeTab]}
                allCount={allCount}
                colors={COLOR_STACK[activeTab]}
                data={tabData[activeTab]}
              />
            </>
          ) : (
            <div className={styles.loader}>
              <IconSpinner size={ICON_HEIGHT_40} />
            </div>
          )}
        </Content>
      </Box>
    </Modal>
  )
}

export default InhabitantsStatisticModal
